// RSC-01 a 03 (Mario, 3-nov): lo ya pagado se dice con el Bs que manda el núcleo, nunca USD × tasa, y una tasa solo se muestra
// si es la real del lote. Funciones puras (las prueba test/liquidacion-resumen-cifras.test.mjs sin Angular).
const num = (x: any): number => Number(x) || 0;
const dos = (x: any): string => num(x).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** «Bs 173.572.286,04». */
export const fmtBs = (x: any): string => `Bs ${dos(x)}`;

/** «Bs …» de lo pagado: el del núcleo (ya trae los asientos). Sin pagos y con tasa, Bs 0,00; sin tasa ni Bs, USD. */
export const textoPagado = (r: any): string => {
  const p = (r && r.pagado) || {};
  if (num(p.bs) > 0) return fmtBs(p.bs);
  return !num(p.usd) && r && r.tasa ? fmtBs(0) : `$ ${dos(p.usd)}`;
};

/** La tasa REAL con la que se generó el lote (la manda el núcleo); null si hay varias o ninguna. Nunca Bs ÷ USD. */
export const tasaReal = (x: any): any => (x && num(x.tasa_lote) > 0 ? num(x.tasa_lote) : null);

/** El USD de lo pagado = lo transferido (neto menos el equivalente USD de los asientos); sin ese dato, el USD de siempre. */
export const usdTransferido = (p: any): number => (p && p.transferido_usd !== undefined && p.transferido_usd !== null ? num(p.transferido_usd) : num(p && p.usd));

// ── RSC-08 a 10 (compactar) ──
const cent = (x: any): number => Math.round(num(x) * 100) / 100;

/** ¿Hay asientos de cuadre vigentes en lo pagado? */
export const hayAsientos = (p: any): boolean => !!p && !!p.asientos && (num(p.asientos.cantidad) > 0 || ((p.asientos.lista || []).length > 0));

/** Neto de la liquidación en Bs = transferido − asientos (con signo): 173.572.286,04 − (−34.682,00) = 173.606.968,04. */
export const netoBs = (p: any): number => cent(num(p && p.bs) - num(p && p.asientos && p.asientos.bs));

/** La tarjeta «Cuadre del pago» sale si hay asientos o hay pago. */
export const mostrarCuadre = (r: any): boolean => !!r && !!r.pagado && (hayAsientos(r.pagado) || num(r.pagado.usd) > 0 || num(r.pagado.bs) > 0);

const MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
/** «Este cierre» o «Cierre del 2-nov» (de CIERRE-20261102). */
export const etiquetaCierre = (code: any, actual: any): string => {
  const c = String(code || '');
  if (c === String(actual || '')) return 'Este cierre';
  const m = /(\d{4})(\d{2})(\d{2})$/.exec(c);
  return m ? `Cierre del ${Number(m[3])}-${MES[Number(m[2]) - 1]}` : c;
};

/** Lo que salió hoy por cierre, solo si el núcleo lo mandó y hay más de uno; si no, solo el total. */
export const desgloseCierres = (salio: any, actual: any): any => {
  const l = (salio && salio.por_cierre) || [];
  return l.length > 1 ? l.map((x: any) => ({ et: etiquetaCierre(x.cierre, actual), bs: cent(x.bs), usd: cent(x.usd), este: String(x.cierre) === String(actual) })) : null;
};

/** El «Detalle del día» se abre solo si hay alertas o el día está abierto con algo que atender (tandas por firmar, lotes abiertos). */
export const abrirDetalle = (r: any, porFirmar: any): boolean => {
  if (!r) return false;
  if ((r.alertas || []).length) return true;
  return !!r.abierto && (num(r.tandas_por_firmar) > 0 || num(r.lotes_abiertos) > 0 || num(porFirmar) > 0);
};
